var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-172 -700)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(172 700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8.656a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V7.656A1,1,0,0,1,0,8.656Z",
    transform: "translate(17.5 11.302)",
    fill: "#f14646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.244-1a5.65,5.65,0,0,1,2.8.744l8.666,5,.007,0A5.665,5.665,0,0,1,26.75,6.8,5.6,5.6,0,0,1,27.5,9.6v9.975a5.645,5.645,0,0,1-2.783,4.843l-.007,0-8.663,5a5.59,5.59,0,0,1-2.791.747,5.65,5.65,0,0,1-2.8-.744l-8.666-5A5.608,5.608,0,0,1-1,19.571V9.6A5.645,5.645,0,0,1,1.783,4.752l.007,0,8.663-5A5.59,5.59,0,0,1,13.244-1ZM23.705,6.479l-8.659-5A3.643,3.643,0,0,0,13.244,1a3.587,3.587,0,0,0-1.791.479l-8.659,5A3.637,3.637,0,0,0,1,9.6v9.975a3.6,3.6,0,0,0,1.79,3.115l8.663,5a3.643,3.643,0,0,0,1.8.478,3.587,3.587,0,0,0,1.791-.479l8.659-5A3.637,3.637,0,0,0,25.5,19.571V9.6A3.59,3.59,0,0,0,23.705,6.479Z",
    transform: "translate(4.244 2.917)",
    fill: "#f14646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H35V35H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.146a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V.146A1,1,0,0,1,0,1.146Z",
    transform: "translate(17.5 23.625)",
    fill: "#f14646"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationIcon);
export default __webpack_public_path__ + "static/media/confirmation-icon.5f0dbd5f8caa925559acbfda21c3ca01.svg";
export { ForwardRef as ReactComponent };